import { RCS_PROVIDERS } from "../../../../utils/constant";

const { KARIX } = RCS_PROVIDERS;

export const getRegisteredRcsTemplatesMutation = (builder) => ({
  getRegisteredRcsTemplates: builder.mutation({
    query: ({
      page = 1,
      limit = "",
      status = "",
      userId = "",
      search = "",
      templateType = "",
      provider = KARIX,
    }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/get_registered_rcs_templates",
        method: "GET",
        params: {
          page,
          limit,
          status,
          userId,
          search,
          template_type: templateType,
          provider,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
